import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Flex,
  SimpleGrid,
  useColorModeValue,
  VStack
} from '@chakra-ui/react';

const FAQ = () => {
  const bgGradient = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  
  const faqItems = [
    {
      question: "What does it cost to use MommaFuel?",
      answer: <>MommaFuel is a free service to use; there are no fees for creating or using MommaFuel.</>
    },
    {
      question: "We don't know when we're coming home from the hospital or when the baby will arrive. How do our friends know when to bring meals?",
      answer: "You or your administrator will set the first delivery date when you know it. A blast notification will be sent to members when the MommaFuel is activated for sign up."
    },
    {
      question: "How early can I create my MommaFuel?",
      answer: "You can create your MommaFuel anytime during your pregnancy. Most parents create their MommaFuel after 30 weeks gestation."
    },
    {
      question: "What meals can I request?",
      answer: "Meals are intended mainly for dinner. However, you can request any meal you want by choosing a lunch drop off time."
    },
    {
      question: "How long does it take to create a MommaFuel?",
      answer: "It takes about 5 minutes. You'll need to provide some basic information about yourself."
    },
    {
      question: "How do I invite friends and family to my MommaFuel?",
      answer: "Once your MommaFuel is created, you'll receive a unique link to share with your friends and family. They can use this link to sign up for meals."
    }
  ];
  
  return (
    <Box 
      bgGradient={bgGradient} 
      minH={{ base: "auto", lg: "calc(100vh - 60px)" }}
      py={{ base: 8, md: 12 }} 
      px={{ base: 4, md: 0 }}
      display="flex"
      alignItems="center"
    >
      <Container maxW="container.xl" flex="1">
        <VStack spacing={8} justify="center" minH={{ base: "auto", lg: "60vh" }}>
          <Heading 
            as="h1" 
            size="lg" 
            fontWeight="bold"
            textAlign="center"
          >
            Frequently Asked Questions
          </Heading>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} width="100%">
            {faqItems.map((item, index) => (
              <Box
                key={index}
                p={6}
                borderWidth="1px"
                borderColor={borderColor}
                borderRadius="lg"
                shadow="md"
                bg="white"
                position="relative"
              >
                <Flex alignItems="flex-start">
                  <Box>
                    <Heading as="h3" size="md" mb={3} textAlign="left" color="mamaFuel.moss.700">
                      {item.question}
                    </Heading>
                    <Text fontSize="md" textAlign="left">{item.answer}</Text>
                  </Box>
                </Flex>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default FAQ; 